import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Button from '../../forms/Button';
import { useDispatch } from 'react-redux';
import { addProduct } from '../../../redux/Cart/cart.actions';
import ReactLoading from 'react-loading';
import { database, firestore, storage, auth } from '../../../firebase/utils';

const JustInProduct = (product) => {
  const dispatch = useDispatch();

  var nf = new Intl.NumberFormat();

  const history = useHistory();

  const [data2, setData] = useState([]);
  const [done, setDone] = useState(undefined);

  useEffect(() => {
    setTimeout(() => {
      fetch('https://jsonplaceholder.typicode.com/posts')
        .then(response => {
          if (!response.ok) {
            throw new Error(response.statusText)
          } else {
            (response.json())
              .then((json) => {
                console.log(json);
                setData(json);
                setDone(true);
              });
          }


        }).catch(err => {
          console.log(err)
        })
    }, 500);

  }, [])

  const {
    documentID,
    image,
    pbrand,
    pname,
    price,
    clicks

  } = product;
  if (!documentID || !image || !pname ||
    typeof price === 'undefined') return null;

  const configAddToCartBtn = {
    type: 'button'
  };

  const handleAddToCart = (product) => {
    if (!product) return;
    dispatch(
      addProduct(product)
    );
    history.push('/cart');
  };



  const handleClick = () => {
    const click = 1
    if (clicks >= 1){
      firestore.collection('Products').doc(documentID).update({

        clicks: clicks + 1,
  
      }).catch((e) => console.log(e));
    }
    else{
      firestore.collection('Products').doc(documentID).update({

        clicks: click,
  
      }).catch((e) => console.log(e));
    }

    
  }

  return (
    <div className="product2">
      <Link to={`/product/${documentID}`} onClick={handleClick}>

        <div className='brand'>
          {pbrand}
        </div>
        <div className="thumb">
          <div className='image' >
            {
              !done ? <ReactLoading className="loader" type="bubbles" color={"rgb(245, 24, 153);"} height={50} width={50} />
                :
                (
                  <img src={image} alt={pname} className='pimage' />
                )
            }
          </div>
        </div>

        <div className="details">
          <ul>
            <li>
              <span className="name">
                {pname}
              </span>
            </li>
            <li>
              <span className="price">
                {'\u20A6'}{nf.format(price)}
              </span>
            </li>
            {/* <li>
            <div className="addToCart">
              <Button {...configAddToCartBtn} onClick={() => handleAddToCart(product)}>
                Add to cart
              </Button>
            </div>
          </li> */}
          </ul>
        </div></Link>

    </div>
  );
};

export default JustInProduct;